export const usersBlockedList = ['']
// eslint-disable-next-line
export const injectionRegex = /['";\(\)\{\}]/
